import {getTradeCollectionPath, Trade, type TradeDb} from '@cp/model';
import {collection, CollectionReference} from 'firebase/firestore';
import {firebaseFirestore} from '../../config/firebase';

export function getTradeCollection(uid: string): CollectionReference<Trade, TradeDb> {
  return collection(firebaseFirestore, getTradeCollectionPath(uid)) as CollectionReference<Trade, TradeDb>;
}
